// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var MenuV5 = require("../../common/Components/menu/MenuV5.bs.js");
var ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var Icon__Jsx3 = require("../../../uikit/reason/atoms/Icon/Icon__Jsx3.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Array = require("@rescript/core/src/Core__Array.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var Theme__Color = require("../../../reason/common/Theme/Theme__Color.bs.js");
var SystemMessages = require("../../../reason/systemMessages/SystemMessages.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var FragmentErrorBoundary = require("../../common/ErrorHandling/FragmentErrorBoundary.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var MyClientsWidgetRowLayout = require("./MyClientsWidgetRowLayout.bs.js");
var MyClientsWidgetComponents = require("./MyClientsWidgetComponents.bs.js");
var MarkPropertyAsRentedDialog = require("../ClientPage/MarkPropertyAsRentedDialog.bs.js");
var MyClientsWidgetDeleteDialog = require("./MyClientsWidgetDeleteDialog.bs.js");
var RenewRentalPropertyMutation = require("../ClientPage/RenewRentalPropertyMutation.bs.js");
var OwnRentalPropertyStatusLabel = require("../OwnRentalPropertyStatusLabel.bs.js");
var WithdrawRentalPropertyDialog = require("../ClientPage/WithdrawRentalPropertyDialog.bs.js");
var MyClientsWidgetLandlord_landlord_graphql = require("../../../__generated__/MyClientsWidgetLandlord_landlord_graphql.bs.js");
var MyClientsWidgetLandlord_Menu_landlord_graphql = require("../../../__generated__/MyClientsWidgetLandlord_Menu_landlord_graphql.bs.js");
var MyClientsWidgetLandlord_name_landlord_graphql = require("../../../__generated__/MyClientsWidgetLandlord_name_landlord_graphql.bs.js");
var MyClientsWidgetLandlord_status_landlord_graphql = require("../../../__generated__/MyClientsWidgetLandlord_status_landlord_graphql.bs.js");

var convertFragment = MyClientsWidgetLandlord_Menu_landlord_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MyClientsWidgetLandlord_Menu_landlord_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(MyClientsWidgetLandlord_Menu_landlord_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, MyClientsWidgetLandlord_Menu_landlord_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(MyClientsWidgetLandlord_Menu_landlord_graphql.node, convertFragment, fRef);
}

var LandlordFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function MyClientsWidgetLandlord$Menu(props) {
  var landlord = use(props.landlord);
  var match = landlord.property.status;
  var isArchived;
  switch (match.__typename) {
    case "ActiveProperty" :
    case "__unselected" :
        isArchived = false;
        break;
    default:
      isArchived = match.archived;
  }
  var hasActivityReport = Core__Array.keepSome(Core__Option.getOr(Core__Option.map(landlord.property.broadcasts, (function (connection) {
                    return connection.edges;
                  })), [])).some(function (edge) {
        var match = edge.node.activityReport;
        if (match.__typename === "ActivityReportV5") {
          return true;
        } else {
          return false;
        }
      });
  var matchesCount = Core__Option.getOr(Core__Option.map(landlord.property.matches, (function (m) {
              return m.totalCount;
            })), 0);
  var match$1 = React.useState(function () {
        return false;
      });
  var setDeleteDialogOpen = match$1[1];
  var match$2 = SystemMessages.useSystemMessages();
  var addMessage = match$2.addMessage;
  var handleRenewingError = function () {
    addMessage(SystemMessages.Message.make(undefined, "error", "There was an error making the property active. Please try again...", 5000, undefined, undefined));
  };
  var match$3 = RenewRentalPropertyMutation.use(landlord.property.id, landlord.property.nodeId, handleRenewingError, false);
  var makePropertyActiveIsLoading = match$3[1];
  var makePropertyActive = match$3[0];
  var match$4 = React.useState(function () {
        return false;
      });
  var setWithdrawDialogOpened = match$4[1];
  var match$5 = React.useState(function () {
        return false;
      });
  var setMarkAsRentedDialogOpened = match$5[1];
  var match$6 = landlord.property.status;
  var submenuName;
  switch (match$6.__typename) {
    case "ActiveProperty" :
        submenuName = match$6.isRenewable ? "Renew or change status" : "Change status";
        break;
    case "ExpiredProperty" :
        submenuName = "Renew or change status";
        break;
    default:
      submenuName = "Change status";
  }
  var tmp;
  if (isArchived) {
    tmp = JsxRuntime.jsx(MenuV5.UnavailableItem.make, {
          name: submenuName,
          unavailableReason: "The property has been archived",
          unavailableDescription: "Archived properties cannot be renewed or have their status changed."
        });
  } else {
    var match$7 = landlord.property.status;
    var tmp$1;
    var exit = 0;
    switch (match$7.__typename) {
      case "ActiveProperty" :
          if (match$7.isRenewable) {
            exit = 1;
          } else {
            tmp$1 = null;
          }
          break;
      case "ExpiredProperty" :
          exit = 1;
          break;
      default:
        tmp$1 = JsxRuntime.jsx(MenuV5.MenuItem.make, {
              onAction: (function () {
                  makePropertyActive();
                }),
              isDisabled: makePropertyActiveIsLoading,
              children: "Change to active"
            });
    }
    if (exit === 1) {
      tmp$1 = JsxRuntime.jsx(MenuV5.MenuItem.make, {
            onAction: (function () {
                makePropertyActive();
              }),
            isDisabled: makePropertyActiveIsLoading,
            children: "Renew property"
          });
    }
    var match$8 = landlord.property.status;
    var tmp$2;
    tmp$2 = match$8.__typename === "RentedProperty" ? null : JsxRuntime.jsx(MenuV5.MenuItem.make, {
            onAction: (function () {
                setMarkAsRentedDialogOpened(function (param) {
                      return true;
                    });
              }),
            children: "Mark as rented"
          });
    var match$9 = landlord.property.status;
    var tmp$3;
    tmp$3 = match$9.__typename === "WithdrawnProperty" ? null : JsxRuntime.jsx(MenuV5.MenuItem.make, {
            onAction: (function () {
                setWithdrawDialogOpened(function (param) {
                      return true;
                    });
              }),
            children: "Withdraw property"
          });
    tmp = JsxRuntime.jsxs(MenuV5.Submenu.make, {
          name: submenuName,
          children: [
            tmp$1,
            tmp$2,
            tmp$3
          ]
        });
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx(WithdrawRentalPropertyDialog.make, {
                      propertyId: landlord.property.id,
                      isOpen: match$4[0],
                      close: (function () {
                          setWithdrawDialogOpened(function (param) {
                                return false;
                              });
                        })
                    }),
                JsxRuntime.jsx(MarkPropertyAsRentedDialog.make, {
                      propertyId: landlord.property.id,
                      isOpen: match$5[0],
                      close: (function () {
                          setMarkAsRentedDialogOpened(function (param) {
                                return false;
                              });
                        })
                    }),
                JsxRuntime.jsx(MyClientsWidgetDeleteDialog.make, {
                      client: landlord.fragmentRefs,
                      isOpen: match$1[0],
                      onCancel: (function () {
                          setDeleteDialogOpen(function (param) {
                                return false;
                              });
                        }),
                      onSuccess: (function () {
                          setDeleteDialogOpen(function (param) {
                                return false;
                              });
                        }),
                      connectionId: props.connectionId
                    }),
                JsxRuntime.jsxs(MenuV5.Menu.make, {
                      button: JsxRuntime.jsx(ButtonsV5.Button.make, {
                            className: "!border-none",
                            children: Caml_option.some(JsxRuntime.jsx(Icon__Jsx3.make, {
                                      icon: "ThreeDots",
                                      size: 16,
                                      color: Theme__Color.black
                                    }))
                          }),
                      children: [
                        isArchived ? JsxRuntime.jsx(MenuV5.UnavailableItem.make, {
                                name: "Edit rental property",
                                unavailableReason: "The property has been archived",
                                unavailableDescription: "Archived properties cannot be edited."
                              }) : JsxRuntime.jsx(MenuV5.MenuItem.make, {
                                href: "/properties/" + landlord.property.id + "/edit",
                                children: "Edit rental property"
                              }),
                        isArchived ? JsxRuntime.jsx(MenuV5.UnavailableItem.make, {
                                name: "Broadcast property",
                                unavailableReason: "The property has been archived",
                                unavailableDescription: "Archived properties cannot be broadcasted."
                              }) : JsxRuntime.jsx(MenuV5.MenuItem.make, {
                                href: "/properties/" + landlord.property.id + "/broadcast",
                                children: "Broadcast property"
                              }),
                        tmp,
                        matchesCount > 0 ? JsxRuntime.jsx(MenuV5.MenuItem.make, {
                                href: "/my_clients/" + landlord.id + "#matches",
                                children: "View matches (" + matchesCount.toString() + ")"
                              }) : null,
                        hasActivityReport ? JsxRuntime.jsx(MenuV5.MenuItem.make, {
                                href: "/properties/" + landlord.property.id + "/report",
                                children: "View activity report"
                              }) : null,
                        isArchived ? JsxRuntime.jsx(MenuV5.UnavailableItem.make, {
                                name: "Delete landlord",
                                unavailableReason: "The property has been archived",
                                unavailableDescription: "Archived properties cannot be deleted."
                              }) : JsxRuntime.jsx(MenuV5.MenuItem.make, {
                                onAction: (function () {
                                    setDeleteDialogOpen(function (param) {
                                          return true;
                                        });
                                  }),
                                children: "Delete landlord"
                              })
                      ]
                    })
              ]
            });
}

var Menu = {
  LandlordFragment: LandlordFragment,
  make: MyClientsWidgetLandlord$Menu
};

var convertFragment$1 = MyClientsWidgetLandlord_status_landlord_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MyClientsWidgetLandlord_status_landlord_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(MyClientsWidgetLandlord_status_landlord_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, MyClientsWidgetLandlord_status_landlord_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(MyClientsWidgetLandlord_status_landlord_graphql.node, convertFragment$1, fRef);
}

var LandlordFragment$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function MyClientsWidgetLandlord$Status$WithoutErrorBoundary(props) {
  var landlord = use$1(props.landlord);
  return JsxRuntime.jsx(OwnRentalPropertyStatusLabel.make, {
              rentalProperty: landlord.property.fragmentRefs
            });
}

var WithoutErrorBoundary = {
  RentalPropertyStatusLabel: undefined,
  LandlordFragment: LandlordFragment$1,
  make: MyClientsWidgetLandlord$Status$WithoutErrorBoundary
};

function MyClientsWidgetLandlord$Status(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
              fragmentDisplayName: "landlord status",
              children: JsxRuntime.jsx(MyClientsWidgetLandlord$Status$WithoutErrorBoundary, {
                    landlord: props.landlord
                  })
            });
}

var Status = {
  WithoutErrorBoundary: WithoutErrorBoundary,
  make: MyClientsWidgetLandlord$Status
};

var convertFragment$2 = MyClientsWidgetLandlord_name_landlord_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MyClientsWidgetLandlord_name_landlord_graphql.node, convertFragment$2, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(MyClientsWidgetLandlord_name_landlord_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, MyClientsWidgetLandlord_name_landlord_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(MyClientsWidgetLandlord_name_landlord_graphql.node, convertFragment$2, fRef);
}

var LandlordFragment_rentalPropertyMatchingType_decode = MyClientsWidgetLandlord_name_landlord_graphql.Utils.rentalPropertyMatchingType_decode;

var LandlordFragment_rentalPropertyMatchingType_fromString = MyClientsWidgetLandlord_name_landlord_graphql.Utils.rentalPropertyMatchingType_fromString;

var LandlordFragment$2 = {
  rentalPropertyMatchingType_decode: LandlordFragment_rentalPropertyMatchingType_decode,
  rentalPropertyMatchingType_fromString: LandlordFragment_rentalPropertyMatchingType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$2,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

function MyClientsWidgetLandlord$Name(props) {
  var landlord = use$2(props.landlord);
  var match = landlord.property.propertyLocation;
  var tmp;
  tmp = match !== undefined && match.__typename === "PropertyLocationWithHiddenAddress" ? JsxRuntime.jsx(MyClientsWidgetComponents.HiddenAddressIcon.make, {}) : null;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: "Rental property",
                              className: "text-gray-500 uppercase font-light"
                            }),
                        tmp
                      ],
                      className: "flex gap-2 items-center"
                    }),
                JsxRuntime.jsx(ButtonsV5.Link.make, {
                      href: "my_clients/" + landlord.id,
                      children: Caml_option.some(JsxRuntime.jsx("div", {
                                children: landlord.displayName,
                                className: "text-lg"
                              }))
                    })
              ],
              className: "flex flex-col gap-1"
            });
}

var Name = {
  LandlordFragment: LandlordFragment$2,
  make: MyClientsWidgetLandlord$Name
};

var convertFragment$3 = MyClientsWidgetLandlord_landlord_graphql.Internal.convertFragment;

function waitForFragmentData$3(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MyClientsWidgetLandlord_landlord_graphql.node, convertFragment$3, fRef);
}

function use$3(fRef) {
  return RescriptRelay_Fragment.useFragment(MyClientsWidgetLandlord_landlord_graphql.node, convertFragment$3, fRef);
}

function useOpt$3(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, MyClientsWidgetLandlord_landlord_graphql.node, convertFragment$3);
}

function readResolverFragment$3(fRef) {
  return RescriptRelay_Fragment.read(MyClientsWidgetLandlord_landlord_graphql.node, convertFragment$3, fRef);
}

var LandlordFragment$3 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$3,
  waitForFragmentData: waitForFragmentData$3,
  use: use$3,
  useOpt: useOpt$3,
  readResolverFragment: readResolverFragment$3
};

function MyClientsWidgetLandlord(props) {
  var landlord = use$3(props.landlord);
  return JsxRuntime.jsx(MyClientsWidgetRowLayout.make, {
              name: JsxRuntime.jsx(MyClientsWidgetLandlord$Name, {
                    landlord: landlord.fragmentRefs
                  }),
              status: JsxRuntime.jsx(MyClientsWidgetLandlord$Status, {
                    landlord: landlord.fragmentRefs
                  }),
              menu: JsxRuntime.jsx(MyClientsWidgetLandlord$Menu, {
                    landlord: landlord.fragmentRefs,
                    connectionId: props.connectionId
                  })
            });
}

var Layout;

var Components;

var Link;

var DeleteDialog;

var make = MyClientsWidgetLandlord;

exports.Layout = Layout;
exports.Components = Components;
exports.Link = Link;
exports.DeleteDialog = DeleteDialog;
exports.Menu = Menu;
exports.Status = Status;
exports.Name = Name;
exports.LandlordFragment = LandlordFragment$3;
exports.make = make;
/* react Not a pure module */
